var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("this is test page")]),_c('button',{on:{"click":_vm.clickBtn}},[_vm._v(" 点击发送请求")])])
}
var staticRenderFns = []

export { render, staticRenderFns }